import styled from "styled-components";

export const Container = styled.div`
  max-height: 312px;
  padding: 27px 30px 10px 40px;
  overflow: auto;
`;
